export const select = {
  option: (base, state) => ({
    ...base,
    fontSize: '2rem',
    backgroundColor: state.isSelected ? '#f4f6f8' : 'transparent',
    color: '#222326',
    fontWeight: 400,

    ':hover': {
      backgroundColor: state.isSelected ? '#f4f6f8' : '#7ab1bc',
      cursor: 'pointer',
      color: state.isSelected ? 'inherit' : '#fff',
    },
  }),
  control: (base, state) => {
    return {
      ...base,
      fontSize: '2rem',
      border: 'none',
      borderBottom: '2px solid #48727b',
      borderColor: state.isFocused ? '#7ab1bc' : '#48727b',
      boxShadow: state.isFocused ? '0' : '0',
      background: '#fff',
      borderRadius: '0',
      padding: '0',
      textTransform: 'capitalize',

      ':hover': {
        borderColor: state.isFocused ? '#7ab1bc' : '#48727b',
      },
    };
  },
  input: (base, state) => {
    return {
      ...base,
      margin: '0',
    };
  },
  group: (base, state) => {
    return {
      ...base,
      padding: '0',
    };
  },
  container: (base, state) => {
    return {
      ...base,
      padding: '0',
      textTransform: 'capitalize',
    };
  },
  valueContainer: (base, state) => {
    return {
      ...base,
      fontWeight: 400,
      padding: '0',
    };
  },
  singleValue: (base, state) => {
    return {
      ...base,
      margin: '0',
    };
  },
  menu: (base, state) => {
    return {
      ...base,
      fontSize: '2rem',
      borderRadius: '0',
      marginTop: '0',
      boxSizing: 'border-box',
    };
  },
  menuList: base => {
    return {
      ...base,
      fontSize: '2rem',
      padding: '0',
    };
  },
  multiValue: base => {
    return {
      ...base,
      fontSize: '1.6rem',
      backgroundColor: '#7bb1bc',
      padding: '0',
      // backgroundColor: `'${(props) => props.theme.color.secondary}'`
    };
  },
  multiValueLabel: base => {
    return {
      ...base,
      color: '#fff',
    };
  },
  multiValueRemove: base => {
    return {
      ...base,
      color: '#fff',
      ':hover': {
        backgroundColor: '#395B61',
        cursor: 'pointer',
      },
    };
  },
};
